import WAddRow from './add-row.vue';
import WAlert from './alert.vue';
import WAutoText from './auto-text.vue';
import WButton from './button.vue';
import WCheckbox from './checkbox.vue';
import WCrossedOut from './crossed-out.vue';
import WDatepicker from './datepicker.vue';
import WDatetime from './datetime.vue';
import WError from './error.vue';
import WFormTable from './form-table.vue';
import WInput from './input.vue';
import WJstPicker from './jstPicker.vue';
import WLpCell from './lp-cell.vue';
import WModal from './modal.vue';
import WMonaco from './monaco.vue';
import WPagination from './pagination.vue';
import WPreview from './preview-value.vue';
import WRadio from './radio';
import WRadioList from './radio-list.vue';
import WRowButtons from './row-buttons.vue';
import WSection from './section.vue';
import WSelect from './select.vue';
import WSimcPicker from './simcPicker.vue';
import WSpoiler from './spoiler.vue';
import WTableCell from './table-cell.vue';
import WTercPicker from './tercPicker.vue';
import WTerytPicker from './terytPicker.vue';
import WTextarea from './textarea.vue';
import WTooltip from './tooltip.vue';
import WUlicPicker from './ulicPicker.vue';
import WVueSelect from './vue-select.vue';
import WWarnings from './warnings';
import WWysiwyg from './wysiwyg.vue';
import WAddressPicker from './addressPicker.vue';

//shared components
import WAddress from './shared/Address.vue';
import WFormDevTools from './shared/FormDevTools.vue';
import WLegalForm from './shared/LegalForm.vue';
import WSphere from './shared/Sphere.vue';

export const components = {
  WInput,
  WPreview,
  WTextarea,
  WPagination,
  WSelect,
  WVueSelect,
  WDatepicker,
  WDatetime,
  WModal,
  WRadio,
  WTooltip,
  WError,
  WAddRow,
  WRowButtons,
  WButton,
  WCheckbox,
  WSection,
  WTableCell,
  WCrossedOut,
  WAutoText,
  WAlert,
  WLpCell,
  WFormTable,
  WSpoiler,
  WRadioList,
  WMonaco,
  WTercPicker,
  WJstPicker,
  WSimcPicker,
  WUlicPicker,
  WTerytPicker,
  WWarnings,
  WWysiwyg,
  WAddressPicker,

  WAddress,
  WLegalForm,
  WSphere,
  WFormDevTools
};

export function registerComponents(Vue, registerLog) {
  for (var name in components) {
    if (registerLog) {
      console.time('register ' + name);
      Vue.component(name, components[name]);
      console.timeEnd('register ' + name);
    } else {
      Vue.component(name, components[name]);
    }
  }
}

export default components;
